module.exports = __webpack_public_path__ + "static/media/create_sections_delete_section.b63609ad.mov";